<template>
  <div @mouseover="onMouseOver" @mouseleave="hideTooltip" ref="target">
    <slot> </slot>
  </div>
</template>

<script setup lang="ts">
import { useTooltip } from '@/composables/useTooltip';
import { useMouseInElement } from '@vueuse/core';
import { ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

const { showTooltip, hideTooltip } = useTooltip();

const props = defineProps<{
  text: string;
}>();

const target = ref(null);

/**
 * x, y: mouse position in perspective of the whole document
 * elementX, elementY: mouse position in perspective of the element
 *
 * @function useMouseInElement
 */
const { x, y, elementX, elementY, elementWidth } = useMouseInElement(target);

/**
 * Calculating the best position for the tooltip and sending that to showTooltip
 * By x-eleX and x-eleY; getting to the 0,0 position of the element
 * Then adding and subtracting values as needed.
 *
 * @function onMouseOver
 */
const onMouseOver = () => {
  const positionX = x.value - elementX.value + elementWidth.value / 2;
  const positionY = y.value - elementY.value - 10;
  showTooltip(props.text, positionX, positionY);
};

// Hide tooltip when leaving the route
onBeforeRouteLeave((to, from, next) => {
  hideTooltip();
  next();
});
</script>
